// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__dTHwd","label":"LabeledBox_label__1SSrh"};